import { useEffect, useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AgencyContext } from 'Context/Agency'
import { Decrypt_Id_Name } from '@/Components/Common/Utility'
import { useDispatch, useSelector } from 'react-redux'
import { get_LocalStoreData } from '@/redux/actions/Agency'
import { Link } from 'react-router-dom'

const PropertyRoomSidebarNew = () => {
    const { getAgency, agencyFilterData, } = useContext(AgencyContext);
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const uniqueId = sessionStorage.getItem('UniqueUserID') ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID') : '';
    const localStoreData = useSelector((state) => state.Agency.localStoreData);

    const useQuery = () => {
        const params = new URLSearchParams(location.search);
        return {
            get: (param) => params.get(param)
        };
    };

    const query = useQuery();
    const [propertyPage, setpropertyPage] = useState(query?.get("propertyPage") || 'evidence-management');

    useEffect(() => {
        if (!localStoreData?.AgencyID || !localStoreData?.PINID) {
            if (uniqueId) dispatch(get_LocalStoreData(uniqueId));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (localStoreData) {
            if (localStoreData.AgencyID && localStoreData.PINID) {
                if (agencyFilterData.length === 0) { getAgency(localStoreData?.AgencyID, localStoreData?.PINID) }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [localStoreData]);

    // Helper function to preserve all URL parameters
    const preserveParams = () => {
        const params = new URLSearchParams(location.search);
        // Preserve all existing parameters except propertyPage
        const newParams = new URLSearchParams();
        params.forEach((value, key) => {
            if (key !== 'propertyPage') {
                newParams.set(key, value);
            }
        });
        return newParams;
    };

    // Handle page navigation
    const handlePageChange = (page) => {
        setpropertyPage(page);
        const params = preserveParams();
        params.set('propertyPage', page);
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    // Update state when URL parameter changes
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const urlPage = params.get("propertyPage");

        if (urlPage) {
            setpropertyPage(urlPage);
        } else {
            setpropertyPage('evidence-management');
        }
    }, [location.search]);
    const navItems = [
        {
            header: 'Property Room', items: [
                { id: 'intake-labeling', label: 'Intake & Labeling', icon: '📦' },
                { id: 'evidence-management', label: 'Evidence Management', icon: '🛡️' },
                // { id: 'bulk-intake-labeling', label: 'Bulk Intake', icon: '🏷️' },
                // { id: 'move-assign-location', label: 'Move / Assign Location', icon: '🚚' },
                // { id: 'chain-of-custody', label: 'Chain of Custody', icon: '⚖️' },
                { id: 'evidence-transfer', label: 'Evidence Transfer', icon: '🔬' },
                { id: 'evidence-destruction', label: 'Evidence Destruction', icon: '🔥' },
                { id: 'legal-hold', label: 'Legal Hold', icon: '⛔' },
                { id: 'vehicle-impound', label: 'Vehicle Impound', icon: '🚗' },
                { id: 'review-queue', label: 'Review Queue', icon: '📋' },
            ]
        },
        // {
        //     header: 'Audit', items: [
        //         { id: 'plan-audit', label: 'Plan Audit', icon: '📝' },
        //         { id: 'blind-count', label: 'Blind Count', icon: '🔢' },
        //         { id: 'reconcile', label: 'Reconcile', icon: '✅' },
        //         { id: 'reports', label: 'Reports', icon: '📊' },
        //         { id: 'history', label: 'History', icon: '📜' },
        //     ]
        // },
        {
            header: 'Admin', items: [
                { id: 'supervisor-approval', label: 'Supervisor Approval', icon: '🛡️' },
                // { id: 'configuration-setup', label: 'Configuration / Setup', icon: '⚙️' },
            ]
        }
    ];


    return (
        <div style={{ backgroundColor: '#f5f5f5', padding: '10px' }}>
            {/* Property Room Header */}
            <div className='agency-sidebar mb-3'>
                <i className="fa fa-chevron-right" style={{ fontSize: '14px' }}></i>
                <span className="ml-2">
                    Property Room
                    <p className='agency-name-sidebar'>{localStoreData?.Agency_Name ? localStoreData?.Agency_Name : ''}</p>
                </span>
            </div>

            {/* Menu Items */}
            <div>
                {navItems.map((group, idx) => (
                    <div key={idx} className="">
                        <div className="text-uppercase text-secondary small fw-bold mb-2 ps-2" style={{ fontSize: '0.75rem', letterSpacing: '1px' }}>
                            {group.header}
                        </div>
                        <ul className="metismenu" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {group.items.map(item => (
                                <li key={item.id} style={{ marginBottom: '5px' }}>
                                    <Link
                                        to="#"
                                        className="d-flex align-items-center p-2"
                                        style={{
                                            textDecoration: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            backgroundColor: propertyPage === item.id ? '#001e3f' : '#e9ecef',
                                            color: propertyPage === item.id ? '#ffffff' : '#333333',
                                            padding: '8px 12px',
                                            fontSize: '14px'
                                        }}
                                        onClick={(e) => {
                                            e.preventDefault();
                                            handlePageChange(item.id);
                                        }}
                                    >
                                        <span style={{ marginRight: '8px', fontSize: '16px' }}>{item.icon}</span>
                                        <span>{item.label}</span>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default PropertyRoomSidebarNew